interface Config {
  [key: string]: {
    baseUrl: string
    productsUrl: string
    mode: 'development' | 'staging' | 'beta' | 'production' | 'interop'
  }
}
const config: Config = {
  development: {
    baseUrl: 'https://staging.services.leadconnectorhq.com/store/customer-access-center',
    productsUrl: 'https://staging.services.leadconnectorhq.com/products',
    mode: 'development',
  },
  staging: {
    baseUrl: 'https://staging.services.leadconnectorhq.com/store/customer-access-center',
    productsUrl: 'https://staging.services.leadconnectorhq.com/products',
    mode: 'staging',
  },
  interop: {
    baseUrl: 'https://interop.services.leadconnectorhq.com/store/customer-access-center',
    productsUrl: 'https://interop.services.leadconnectorhq.com/products',
    mode: 'interop',
  },
  beta: {
    baseUrl: 'https://beta-dot-highlevel-backend.appspot.com',
    productsUrl: 'https://beta-dot-highlevel-backend.appspot.com/products',
    mode: 'beta',
  },
  production: {
    baseUrl: 'https://backend.leadconnectorhq.com/store/customer-access-center',
    productsUrl: 'https://backend.leadconnectorhq.com/products',
    mode: 'production',
  },
}

export default config[import.meta.env.MODE ?? 'development']
